export default __webpack_public_path__ + "static/media/1_curiosidade.cf9379f1.svg";